import { AppHeroSwitch, SwitchThumb } from '@components/HeroSwitch'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { HeroIcon } from '@components/HeroIcon'

interface IAutoPlaySwitchProps {
  isActive: boolean
  icon: IconProp
  onPress: () => void
}

export function AutoPlaySwitch({
  isActive = false,
  icon,
  onPress,
}: IAutoPlaySwitchProps) {
  return (
    <AppHeroSwitch
      defaultChecked={isActive}
      active={isActive}
      onPress={onPress}
      height={15}
      width={36}
      backgroundColor={isActive ? '$cross-300' : '$control-inactive'}
      borderColor={isActive ? '$cross-300' : '$control-inactive'}
    >
      <SwitchThumb
        width={21}
        height={21}
        animation="medium"
        top={-5}
        left={isActive ? 6 : -6}
        right={-6}
        backgroundColor={isActive ? '$cross-100' : '$cross-400'}
      >
        <HeroIcon
          icon={icon}
          size={10}
          color={isActive ? '$cross-500' : '$cross-100'}
        />
      </SwitchThumb>
    </AppHeroSwitch>
  )
}
